import axios from "axios";


export const get100Coins = () => {
    const DASHBOARD_API_URL = "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=100&page=1&sparkline=false";
  const data = axios
    .get(DASHBOARD_API_URL)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("Error>>>", error);
    });

  return data;
};